export const COMETCHAT_CONSTANTS = {
  APP_ID: "2493236f7f359ab3", //Replace with your App ID
  REGION: "in", //Replace with your App Region
  AUTH_KEY: "2c4ed6147df0ded4d579e34cdad251f56a9c8fff", //Replace with your Auth Key
};

